export const THEME_GROUPS: { title: string; items: { k: string; v: string; label: string; def: string }[] }[] = [
  { title: "Page", items: [
    { k: "background", v: "--c-bg", label: "Page background", def: "#FAF9F6" },
    { k: "foreground", v: "--c-fg", label: "Main text", def: "#111111" },
    { k: "soft_text", v: "--c-soft", label: "Secondary text", def: "#3a3a3a" },
    { k: "muted", v: "--c-muted", label: "Soft panels", def: "#F2EEE6" },
    { k: "border", v: "--c-border", label: "Lines & borders", def: "#E5E5E5" },
  ] },
  { title: "Brand", items: [
    { k: "primary", v: "--c-primary", label: "Accent (links, stars, highlights)", def: "#B8963E" },
    { k: "price", v: "--c-price", label: "Prices", def: "#111111" },
    { k: "selected", v: "--c-selected", label: "Selected options", def: "#171717" },
    { k: "announcement", v: "--c-announcement", label: "Announcement bar", def: "#5B2A86" },
  ] },
  { title: "Buttons", items: [
    { k: "button_bg", v: "--c-btn-bg", label: "Button", def: "#111111" },
    { k: "button_fg", v: "--c-btn-fg", label: "Button text", def: "#FAF9F6" },
    { k: "button_hover_bg", v: "--c-btn-hover-bg", label: "Button hover", def: "#B8963E" },
    { k: "button_hover_fg", v: "--c-btn-hover-fg", label: "Button hover text", def: "#FFFFFF" },
  ] },
  { title: "Header & footer", items: [
    { k: "header_bg", v: "--c-header-bg", label: "Header background", def: "#FAF9F6" },
    { k: "header_fg", v: "--c-header-fg", label: "Header text & icons", def: "#111111" },
    { k: "footer_bg", v: "--c-footer-bg", label: "Footer background", def: "#F0EDE7" },
    { k: "footer_fg", v: "--c-footer-fg", label: "Footer text", def: "#1A1A1A" },
  ] },
];

export const THEME_KEYS: [string, string][] = THEME_GROUPS.flatMap((g) => g.items.map((i) => [i.k, i.v] as [string, string]));

export const shown = (xs: any[] = []) => xs.filter((x) => x && !x.hidden);
export const visibleColumns = (cols: any[] = []) => shown(cols).map((c) => ({ ...c, links: shown(c.links) })).filter((c) => c.links.length);

export const DEFAULT_PROMO = { eyebrow: "Bespoke", title: "Design your own ring", url: "/ring-builder", image: "https://static.prod-images.emergentagent.com/jobs/44826bd6-8ecb-4bb0-82b1-f292e9ea507b/images/96a6c105852a742dfa1491365fe16e6d215598bd3959173987f4e2828b7c561c.jpeg" };

export const isDark = (hex?: string) => {
  const m = (hex || "").match(/^#([0-9a-f]{6})$/i);
  if (!m) return false;
  const n = parseInt(m[1], 16);
  return 0.299 * (n >> 16) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255) < 110;
};

export const PRESETS: { name: string; theme: Record<string, string> }[] = [
  { name: "Somnio Classic", theme: {} },
  { name: "Royal Purple", theme: { primary: "#6B3FA0", button_hover_bg: "#6B3FA0", announcement: "#5B2A86", selected: "#3D1F63", muted: "#F1ECF6", footer_bg: "#EEE8F4" } },
  { name: "Midnight Luxe", theme: { background: "#0F1115", foreground: "#F4F1EA", soft_text: "#C9C4BA", muted: "#1A1D23", border: "#2A2E36", primary: "#C9A55C", price: "#F4F1EA", selected: "#C9A55C",
    button_bg: "#C9A55C", button_fg: "#0F1115", button_hover_bg: "#F4F1EA", button_hover_fg: "#0F1115", header_bg: "#0F1115", header_fg: "#F4F1EA", footer_bg: "#15181E", footer_fg: "#F4F1EA", announcement: "#C9A55C" } },
  { name: "Blush Rose", theme: { background: "#FBF7F5", primary: "#B76E79", button_hover_bg: "#B76E79", muted: "#F5E9E6", footer_bg: "#F3E6E2", announcement: "#B76E79", selected: "#5A2E36" } },
  { name: "Emerald", theme: { primary: "#1F6E5A", button_hover_bg: "#1F6E5A", muted: "#E9F1EE", footer_bg: "#E6EFEB", announcement: "#174F41", selected: "#174F41" } },
];
